import React, { useCallback, useEffect, useMemo, useState } from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import AutocompleteField from 'forms/fields/AutocompleteField';

const { block } = bem('problems-field');
const ProblemsAutocompleteField = ( props ) => {
    const { problemsOptions, setProblem = () => {}, problem, comment, setComment } = props;
    const [ options, setOptions ] = useState([]);
    const [ disabled, setDisabled ] = useState(false);

    const [ value, setValue ] = useState(comment);

    const onInputChange = useCallback((e, value) => {
        if (options.length !== 0) {
            const option = options.find(x => x.label === value);
            if (option) {
                setProblem(option.value);
            } else {
                setProblem(null);
            }
        }
        setComment(value);
    }, [options, problem])

    useEffect(() => {
        if (problem) {
            const option = options.find(x => x.value === problem);
            if (option) {
                setValue(option.label);
                return;
            }
        }
        setValue(null);
    }, [options, problem])

    useEffect(() => {
        const currentOptions =  problemsOptions;
        if (currentOptions.size > 0 ) {
            const rest = Array.from(currentOptions).map(
                ([id, value]) => ({
                    value: id,
                    label: value
                })
            ).sort(({label: label1}, {label: label2}) => label1.localeCompare(label2));
            setDisabled(rest.length === 1);
            if (rest.length === 1) {
                setProblem(rest[0].value);
            }
            setOptions(
                rest
            );
        }
    }, [ problemsOptions ])

    const autocompleteOptions = useMemo(() => {
        return [...new Set(options.map(option => option.label))];
    }, [options]);

    return (
        <AutocompleteField className={block()} name={'autocomplete-field'}
                           value={value}
                           options={autocompleteOptions}
                           disabled={disabled}
                           onInputChange={onInputChange}
                           freeSolo={true}
                           placeholder={'Выберите или введите свой запрос'} />
    )
}

export default observer(ProblemsAutocompleteField);
